const SPAN_ID_RE = /^[0-9a-f]{16}$/;

export function isValidSpanId(value: string): boolean {
  return SPAN_ID_RE.test(value);
}
